export enum QuestionType {
  Text = 'text',
  Boolean = 'boolean',
  RadioGroup = 'radiogroup',
  Rating = 'rating',
  Checkbox = 'checkbox',
  Dropdown = 'dropdown',
  MultiSelectDropdown = 'tagbox',
  Comment = 'comment',
  Matrix = 'matrix',
  Mixer = 'mixer',
}
